import AppStateModel from './../../../model/appStateModel';

export default class PersonComparisonModel {

    private static _people: any;

    static set people(object) {
        /*
         This should be an object containing same person-fields as a normal AppStateModel contains,
         only multiple people and with the addition of "name";

         {
            left: {gender: "m", birthday: 1982, estimated_age: 87, name: Max},
            right: {another person}}
         }

         */
        PersonComparisonModel._people = object;
    }

    static get people() {

        return PersonComparisonModel._people;
    }

    static getResultsByBirthdayAndGender(birthyear = AppStateModel.birthday, gender = AppStateModel.gender, resultsMap = AppStateModel.birthdayMap) {

        return AppStateModel.getResultsByBirthdayAndGender(birthyear, gender, resultsMap);
    }
}
